var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMailBulk = function SvgMailBulk(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3 4H6.7C5.765 4 5 4.787 5 5.75v10.5c0 .962.765 1.75 1.7 1.75h13.6c.935 0 1.7-.788 1.7-1.75V5.75C22 4.787 21.235 4 20.3 4m-.34 3.719-5.559 3.578a1.64 1.64 0 0 1-1.802 0L7.04 7.72a.75.75 0 0 1-.34-.63c0-.586.62-.937 1.105-.63l5.695 3.666 5.695-3.666c.485-.306 1.105.044 1.105.63 0 .253-.128.49-.34.63"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 22q-.824 0-1.412-.587A1.93 1.93 0 0 1 1 20V8q0-.424.288-.713A.97.97 0 0 1 2 7q.424 0 .712.287Q3 7.576 3 8v12h14q.424 0 .712.288.288.287.288.712 0 .424-.288.712A.97.97 0 0 1 17 22z"
  })));
};
export default SvgMailBulk;